import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { useOptionalT } from '@/lib/i18n';

import { Icon } from './Icon';

export interface BackLinkProps {
  to: string;
  label?: string;
  tone?: 'default' | 'onDark';
  size?: 'sm' | 'md';
  children?: ReactNode;
}

export function BackLink({
  to,
  label,
  tone = 'default',
  size = 'md',
  children,
}: BackLinkProps) {
  const t = useOptionalT();
  const accessibleLabel = label ?? t('common.back');
  const dimensions = size === 'sm' ? 'h-11 w-11' : 'h-11 w-11';
  const colours =
    tone === 'onDark'
      ? 'text-white/80 hover:bg-white/10 hover:text-white'
      : 'text-ink-700 hover:bg-ink-100';

  return (
    <Link
      to={to}
      aria-label={accessibleLabel}

      className={`inline-flex ${dimensions} shrink-0 items-center justify-center rounded-[8px] no-underline transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 ${colours}`}
    >
      <Icon name="arrow-left" size={size === 'sm' ? 15 : 18} />
      {children ? <span className="ml-1.5 text-body-s font-semibold">{children}</span> : null}
    </Link>
  );
}